export const saveUserSetting = (key: string, value: any) => {
  try {
    const serializedValue = JSON.stringify(value)
    localStorage.setItem(key, serializedValue)
  } catch (error) {
    console.error('Error while saving to localStorage', error)
  }
}

export const getUserSetting = (key: string) => {
  try {
    const serializedValue = localStorage.getItem(key)
    return serializedValue ? JSON.parse(serializedValue) : null
  } catch (error) {
    console.error('Error retrieving from localStorage', error)
    return null
  }
}

export const removeUserSetting = (key: string) => {
  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.error('Error when deleting from localStorage', error)
  }
}
